import controller from './listaMerchantSuperAdmin.controller';
import template from './listaMerchantSuperAdmin.html';

const listaMerchantSuperAdminComponent = {
  restrict: 'E',
  template,
  controller
};

export default listaMerchantSuperAdminComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/listaMerchantSuperAdmin/listaMerchantSuperAdmin.component.js
 **/